<div class="qb-social-media-container">
  <app-social-media-home *ngIf="selectedTab=='home'"></app-social-media-home>
  <app-social-media-insights  *ngIf="selectedTab=='insights'"></app-social-media-insights>
  <app-social-media-my-posts *ngIf="selectedTab=='posts'"></app-social-media-my-posts>
</div>